import { CommonModule } from "@angular/common";
import { Component, EventEmitter, Output, TemplateRef, ViewChild } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { NgbModalRef, NgbModalOptions, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { Child, Variant } from "../../../q-commerce/models/category-group.model";
import { ServicesService } from "../../services/services.service";

@Component({
  selector: "app-change-service-modal",
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: "./change-service-modal.component.html",
  styleUrl: "./change-service-modal.component.scss"
})
export class ChangeServiceModalComponent {
  selectedProduct!: Child;
  selectedVariant!: Variant;
  changeServiceModalRef!: NgbModalRef;
  @Output() onModalClosed = new EventEmitter<{ product: Child; variant?: Variant }>();
  @ViewChild("changeServiceModal", { static: true }) changeServiceModal!: TemplateRef<any>;
  config: NgbModalOptions = { size: "sm", centered: true, backdrop: "static" };

  constructor(private servicesService: ServicesService, private modalService: NgbModal) {}

  openModal(product: Child, variant?: Variant): void {
    this.changeServiceModalRef = this.modalService.open(this.changeServiceModal, { ...this.config });
    this.selectedProduct = product;
    if (variant) {
      this.selectedVariant = variant;
    }
  }

  closeModal(): void {
    this.changeServiceModalRef.close();
  }

  clearCart(): void {
    localStorage.removeItem("serviceCartItems");
    localStorage.removeItem("cartServiceItemMainCategory");
    this.servicesService.updateCartItems([]);
    this.closeModal();
    this.onModalClosed.emit({
      product: this.selectedProduct,
      variant: this.selectedVariant
    });
  }
}
